import React, { createContext, useState, useContext } from "react";

// Create a Context for the Lucky Draw
const AdminContext = createContext();

// Create a provider component
export const AdminProvider = ({ children }) => {
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedAdminRole, setSelectedAdminRole] = useState({
    id: null,
    name: "",
  });
  const [actionOpen, setActionOpen] = useState(false);
  const [adminRoleOpen, setAdminRoleOpen] = useState(false);
  const [adminRoles, setAdminRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  return (
    <AdminContext.Provider
      value={{
        selectedAdmin,
        setSelectedAdmin,
        selectedAdminRole,
        setSelectedAdminRole,
        actionOpen,
        setActionOpen,
        adminRoleOpen,
        setAdminRoleOpen,
        adminRoles,
        setAdminRoles,
        isLoading,
        setIsLoading,
        isUpdating,
        setIsUpdating,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

// Custom hook to use the Lucky Draw context
export const useAdminContext = () => useContext(AdminContext);
